'use strict';

/**
 * Shared mutable state for the Bambuser Live Shopping integration.
 *
 * Centralised here so every module reads/writes the same objects
 * without circular-dependency issues.
 */

/** Maps Bambuser product IDs → SFCC PIDs. */
export var bambuserProductIdToPid = {};

/** Maps raw product references (sku/ref) → SFCC PIDs. */
export var bambuserReferenceToPid = {};

/** Mirrors the native SFCC cart: pid → quantity. */
export var nativeCartMirror = {};

/**
 * Baseline SFCC cart quantities captured when the player opens.
 * Used to offset UPDATE_ITEM_IN_CART targets so pre-existing items
 * are not affected by player-session removals.
 */
export var nativeCartBaseline = {};

/** Tracks in-flight PROVIDE_PRODUCT_DATA hydrations: productId → Promise. */
export var pendingHydrationByProductId = {};

/**
 * Replaces the entire nativeCartMirror object.
 * Necessary because reassigning an exported `var` from outside the module
 * is not allowed in ES modules — callers must use this setter instead.
 */
export function resetNativeCartMirror (replacement) {
    // Clear all existing keys …
    var key;
    for (key in nativeCartMirror) {
        if (Object.prototype.hasOwnProperty.call(nativeCartMirror, key)) {
            delete nativeCartMirror[key];
        }
    }

    // … then copy in the new values.
    if (replacement && typeof replacement === 'object') {
        for (key in replacement) {
            if (Object.prototype.hasOwnProperty.call(replacement, key)) {
                nativeCartMirror[key] = replacement[key];
            }
        }
    }
}

/**
 * Copies the current nativeCartMirror into nativeCartBaseline.
 * Call once when the player first opens so UPDATE_ITEM_IN_CART can
 * distinguish player-session quantities from pre-existing ones.
 */
export function snapshotNativeCartBaseline () {
    var key;
    for (key in nativeCartBaseline) {
        if (Object.prototype.hasOwnProperty.call(nativeCartBaseline, key)) {
            delete nativeCartBaseline[key];
        }
    }

    for (key in nativeCartMirror) {
        if (Object.prototype.hasOwnProperty.call(nativeCartMirror, key)) {
            nativeCartBaseline[key] = nativeCartMirror[key];
        }
    }
}
